<template>
  <v-card elevation="0" class="mt-4">
    <v-card-title>
      <v-icon left color="primary">mdi-clock-plus-outline</v-icon>
      <span style="font-size: 1.3rem; font-weight: 600">Time Doctor 2 Integration</span>
    </v-card-title>
    <v-card-subtitle>
      Payroll hours combine Time Doctor Classic and Time Doctor 2. Log in once with a Time Doctor 2 admin account;
      the password is not stored.
    </v-card-subtitle>
    <v-divider></v-divider>

    <v-card-text>
      <div v-if="loading" class="text-center py-4">
        <v-progress-circular indeterminate color="primary" />
      </div>

      <div v-else-if="status.is_connected">
        <v-alert type="success" dense outlined>
          <strong>Time Doctor 2 Connected</strong>
          <div class="text-caption mt-1">
            Company: {{ status.company_name }} · Connected as {{ status.connected_email }}
            <span v-if="status.expires_at"> · Token expires {{ $date(status.expires_at).format("D MMM YYYY") }}</span>
          </div>
        </v-alert>
        <div class="text-right">
          <v-btn color="error" outlined class="text-none" :loading="saving" @click="disconnect">
            <v-icon left small>mdi-link-off</v-icon>
            Disconnect Time Doctor 2
          </v-btn>
        </div>
      </div>

      <v-form v-else ref="form" @submit.prevent="connect" style="max-width: 500px">
        <v-text-field v-model="email" label="Time Doctor 2 admin email" type="email" outlined dense autocomplete="off" />
        <v-text-field v-model="password" label="Password" type="password" outlined dense autocomplete="new-password" />
        <v-text-field v-model="totpCode" label="2FA code (only if enabled)" outlined dense autocomplete="off" />
        <v-btn color="primary" class="text-none" type="submit" :loading="saving" :disabled="!email || !password">
          <v-icon left>mdi-link-variant</v-icon>
          Connect Time Doctor 2
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "TimeDoctor2ConnectView",
  data() {
    return {
      loading: false,
      saving: false,
      status: {},
      email: "",
      password: "",
      totpCode: "",
    };
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/payroll/time-doctor2/status");
        if (response.data?.response) this.status = response.data.data;
      } finally {
        this.loading = false;
      }
    },
    async connect() {
      this.saving = true;
      try {
        const response = await this.$axios.post("/api/payroll/time-doctor2/connect", {
          email: this.email,
          password: this.password,
          totp_code: this.totpCode || null,
        });
        if (response.data?.response) {
          this.status = response.data.data;
          this.$toast.success(response.data.message);
        } else {
          this.$toast.error(response.data?.message || "Failed to connect Time Doctor 2");
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "Failed to connect Time Doctor 2");
      } finally {
        this.password = "";
        this.totpCode = "";
        this.saving = false;
      }
    },
    async disconnect() {
      this.saving = true;
      try {
        const response = await this.$axios.post("/api/payroll/time-doctor2/disconnect");
        if (response.data?.response) {
          this.status = {};
          this.$toast.success("Time Doctor 2 disconnected");
        }
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
